/* AIGI strap upsell test - 2026-06-28. Draft theme only. */
(function () {
  const VIEW_NAME = 'compatible-straps-json';
  const PRODUCT_LIMIT = 3;
  const CART_LIMIT = 2;
  const STRAP_CACHE = new Map();

  function routeRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function productPathFromUrl(url) {
    const parsed = new URL(url, window.location.origin);
    const marker = '/products/';
    const markerIndex = parsed.pathname.indexOf(marker);

    if (markerIndex === -1) {
      return null;
    }

    const prefix = parsed.pathname.slice(0, markerIndex);
    const handle = parsed.pathname.slice(markerIndex + marker.length).split('/')[0];

    if (!handle) {
      return null;
    }

    return `${prefix}${marker}${handle}`;
  }

  function currentProductPath() {
    return productPathFromUrl(window.location.href);
  }

  async function fetchCompatibleStraps(productPath) {
    if (!productPath) {
      return [];
    }

    if (STRAP_CACHE.has(productPath)) {
      return STRAP_CACHE.get(productPath);
    }

    const promise = fetch(`${productPath}?view=${VIEW_NAME}`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) {
          return { straps: [] };
        }

        return response.json();
      })
      .then((data) => Array.isArray(data.straps) ? data.straps.filter((strap) => strap && strap.available) : [])
      .catch(() => []);

    STRAP_CACHE.set(productPath, promise);
    return promise;
  }

  function ensureStyles() {
    if (document.getElementById('aigi-strap-upsell-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'aigi-strap-upsell-style';
    style.textContent = `
      .aigi-strap-upsell {
        border: 1px solid rgba(0, 0, 0, 0.14);
        margin: 24px 0;
        padding: 18px 18px 14px;
        background: #fff;
      }

      .aigi-strap-upsell--cart {
        border-width: 1px 0;
        margin: 18px 0 0;
        padding: 16px 0 6px;
      }

      .aigi-strap-upsell__heading {
        margin: 0 0 10px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .12em;
        text-transform: uppercase;
      }

      .aigi-strap-upsell__text {
        margin: 0 0 14px;
        color: rgb(var(--text-color));
        opacity: .72;
        font-size: 13px;
        line-height: 1.5;
      }

      .aigi-strap-upsell__list {
        display: grid;
        gap: 12px;
      }

      .aigi-strap-upsell__item {
        display: grid;
        grid-template-columns: 54px minmax(0, 1fr) auto;
        align-items: center;
        gap: 14px;
      }

      .aigi-strap-upsell--cart .aigi-strap-upsell__item {
        grid-template-columns: 48px minmax(0, 1fr) auto;
      }

      .aigi-strap-upsell__image {
        width: 54px;
        height: 54px;
        object-fit: contain;
        background: #f7f7f7;
      }

      .aigi-strap-upsell--cart .aigi-strap-upsell__image {
        width: 48px;
        height: 48px;
      }

      .aigi-strap-upsell__title {
        display: block;
        color: inherit;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.35;
        text-decoration: none;
        text-transform: uppercase;
      }

      .aigi-strap-upsell__price {
        display: block;
        margin-top: 3px;
        font-size: 12px;
      }

      .aigi-strap-upsell__button {
        border: 0;
        background: transparent;
        color: inherit;
        cursor: pointer;
        font: inherit;
        font-size: 13px;
        padding: 4px 0;
        text-decoration: underline;
        white-space: nowrap;
      }

      .aigi-strap-upsell__button[disabled] {
        cursor: default;
        opacity: .55;
      }

      @media screen and (max-width: 740px) {
        .aigi-strap-upsell { padding: 16px 14px 12px; }
        .aigi-strap-upsell__item { grid-template-columns: 48px minmax(0, 1fr) auto; gap: 12px; }
        .aigi-strap-upsell__image { width: 48px; height: 48px; }
        .aigi-strap-upsell__title { font-size: 12px; }
      }
    `;

    document.head.appendChild(style);
  }

  function createUpsellBlock(straps, context) {
    const block = document.createElement('div');
    block.className = `aigi-strap-upsell aigi-strap-upsell--${context}`;
    block.dataset.aigiStrapUpsell = context;

    const heading = document.createElement('p');
    heading.className = 'aigi-strap-upsell__heading';
    heading.textContent = context === 'cart' ? 'Compatible extra strap' : 'Add an extra strap';
    block.appendChild(heading);

    const text = document.createElement('p');
    text.className = 'aigi-strap-upsell__text';
    text.textContent = context === 'cart' ? 'Fits a watch in your cart.' : 'Compatible straps for this watch.';
    block.appendChild(text);

    const list = document.createElement('div');
    list.className = 'aigi-strap-upsell__list';

    straps.forEach((strap) => {
      const item = document.createElement('div');
      item.className = 'aigi-strap-upsell__item';

      const imageLink = document.createElement('a');
      imageLink.href = strap.url;
      imageLink.tabIndex = -1;

      const image = document.createElement('img');
      image.className = 'aigi-strap-upsell__image';
      image.loading = 'lazy';
      image.alt = strap.title || '';

      if (strap.image) {
        image.src = strap.image;
      }

      imageLink.appendChild(image);

      const meta = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'aigi-strap-upsell__title';
      title.href = strap.url;
      title.textContent = strap.title;

      const price = document.createElement('span');
      price.className = 'aigi-strap-upsell__price';
      price.textContent = strap.price;

      meta.appendChild(title);
      meta.appendChild(price);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aigi-strap-upsell__button';
      button.dataset.aigiStrapAdd = String(strap.variant_id);
      button.textContent = '+ Add';

      item.appendChild(imageLink);
      item.appendChild(meta);
      item.appendChild(button);
      list.appendChild(item);
    });

    block.appendChild(list);
    return block;
  }

  function removeBlock(context) {
    document.querySelectorAll(`[data-aigi-strap-upsell="${context}"]`).forEach((element) => element.remove());
  }

  async function renderProductUpsell() {
    const productPath = currentProductPath();

    if (!productPath) {
      return;
    }

    const productForm = document.querySelector('.shopify-section--main-product .product-form');

    if (!productForm) {
      return;
    }

    const straps = (await fetchCompatibleStraps(productPath)).slice(0, PRODUCT_LIMIT);
    removeBlock('product');

    if (straps.length === 0) {
      return;
    }

    ensureStyles();
    const block = createUpsellBlock(straps, 'product');
    const anchor = productForm.querySelector('[data-block-type="buy-buttons"]') || productForm.querySelector('.product-form__buy-buttons');

    if (anchor) {
      productForm.insertBefore(block, anchor);
    } else {
      productForm.appendChild(block);
    }
  }

  async function fetchCart() {
    return fetch(`${routeRoot()}cart.js`, { credentials: 'same-origin' }).then((response) => response.json());
  }

  async function renderCartUpsell() {
    const drawer = document.getElementById('mini-cart');
    const form = drawer ? drawer.querySelector('#mini-cart-form') : null;

    if (!drawer || !form) {
      return;
    }

    removeBlock('cart');

    const cart = await fetchCart().catch(() => null);

    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return;
    }

    const variantIdsInCart = new Set(cart.items.map((item) => String(item.variant_id)));
    const suggestedVariantIds = new Set();
    const suggestions = [];

    for (const item of cart.items) {
      const productPath = productPathFromUrl(item.url || `/products/${item.handle}`);
      const straps = await fetchCompatibleStraps(productPath);

      for (const strap of straps) {
        const variantId = String(strap.variant_id);

        if (variantIdsInCart.has(variantId) || suggestedVariantIds.has(variantId)) {
          continue;
        }

        suggestions.push(strap);
        suggestedVariantIds.add(variantId);

        if (suggestions.length >= CART_LIMIT) {
          break;
        }
      }

      if (suggestions.length >= CART_LIMIT) {
        break;
      }
    }

    if (suggestions.length === 0) {
      return;
    }

    ensureStyles();
    form.insertAdjacentElement('afterend', createUpsellBlock(suggestions, 'cart'));
  }

  let cartTimer = null;

  function scheduleCartUpsell() {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(renderCartUpsell, 450);
  }

  async function addStrap(button) {
    const variantId = button.dataset.aigiStrapAdd;

    if (!variantId) {
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';

    try {
      const response = await fetch(`${routeRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });

      if (!response.ok) {
        throw new Error('Could not add strap');
      }

      const cart = await fetchCart().catch(() => null);
      button.textContent = 'Added';

      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      const drawer = document.getElementById('mini-cart');

      if (drawer) {
        drawer.open = true;
      }

      window.setTimeout(scheduleCartUpsell, 700);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-aigi-strap-add]');

    if (button) {
      event.preventDefault();
      addStrap(button);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    renderProductUpsell();
    scheduleCartUpsell();
  });

  document.addEventListener('cart:updated', scheduleCartUpsell);
  document.addEventListener('variant:added', scheduleCartUpsell);
  document.documentElement.addEventListener('cart:refresh', scheduleCartUpsell);
}());
